import { Component } from '@angular/core';
import { PATHS } from 'models/bary-paths.model';
import { TunnelStep } from '../../../models/tunnel-step.model';

@Component({
  selector: 'jhi-my-registered-address',
  templateUrl: './my-registered-addresses.component.html',
})
export class MyRegisteredAddressesComponent {
  public PATHS = PATHS;

  public steps: TunnelStep[] = [
    { title: 'my-registered-addresses.pickup', url: '/' + PATHS.USER_MY_REGISTERED_ADDRESSES_PICKUP.path },
    { title: 'my-registered-addresses.delivery', url: '/' + PATHS.USER_MY_REGISTERED_ADDRESSES_DELIVERY.path },
  ] as TunnelStep[];
}
